import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Footer({ className = '' }) {
  const { t } = useTranslation()

  return (
    <footer className={`bg-brand-gold text-brand-blue py-4 ${className}`}>
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-2 text-center md:text-left">
        <span className="font-display font-bold text-sm md:text-base">
          Światy Równoległe sp.z.o.o. z siedzibą w Krakowie
        </span>
        <nav className="flex items-center gap-4 font-display font-bold text-sm md:text-base">
          <Link to="/regulamin" className="hover:text-brand-orange transition">
            {t('footer.regulamin')}
          </Link>
          <span aria-hidden="true">|</span>
          <Link to="/rodo" className="hover:text-brand-orange transition">
            {t('footer.privacyPolicy')}
          </Link>
        </nav>
      </div>
    </footer>
  )
}
